import { useEffect, useState } from "react";
import { Alert, Button, Space, Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setQA } from "../../redux/slices/qAType";
import { useApiCall } from "../../services/api";
import { ShowData } from "../../utils/ShowData";
import { filterDataFunc } from "../../constant";
import { formatDate } from "../../utils/DateFormat";

const TableComponent = ({
  updatedColumns,
  data = [],
  isCheck = false,
  callApiArgs = {},
  tableConfig = {},
  emptyText,
  ...rest
}) => {
  const [apiFilters, setApiFilters = { setApiFilters }] = useState({
    query: {},
    body: {},
  });

  const { callApi, loading } = useApiCall();
  const { callApi: callApiFirst5000, loading: loadingFirst5000 } = useApiCall();
  const [fetchRefresh, setFetchRefresh] = useState(false);
  const [first5000Data, setFirst5000Data] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const { searchText } = useSelector((state) => state.search);
  const role = useSelector((state) => state.auth.role);

  const [pagination, setPagination] = useState({
    current: 1,
    // pageSize: isCheck ? 9 : 10,
    pageSize: 10,
    total: 0,
  });

  const fetchData = async () => {
    const { getTableData, dataMapper } = tableConfig;
    const {
      endpoint = "",
      bodyData = {},
      queryParams = {},
      showToast = false,
      apiMethod = "get",
      useToken = true,
      accessorKey = "data",
      totalKey = "total_count",
    } = callApiArgs;

    try {
      const res = await callApi({
        endpoint,
        bodyData: { ...bodyData, ...apiFilters.body },
        queryParams: {
          ...queryParams,
          ...apiFilters.query,
          page: pagination.current - 1,
          limit: pagination.pageSize,
          keywords: searchText,
        },
        showToast,
        apiMethod,
        useToken,
        loader: false,
      });

      const { useDecrypted = true } = callApiArgs;
      const { decrypted, responseData } = res;
      let dataToUse = (useDecrypted ? decrypted : responseData) || {};

      // console.log("API Response:", dataToUse); // Debug log

      let mainData = [];
      let totalItems = 0;

      if (Array.isArray(dataToUse)) {
        mainData = dataToUse;
        totalItems = dataToUse?.length;
      } else if (dataToUse?.[accessorKey] && Array.isArray(dataToUse?.[accessorKey])) {
        mainData = dataToUse?.[accessorKey];
        totalItems = dataToUse?.[totalKey] || dataToUse?.[accessorKey]?.length;
      } else if (typeof dataToUse === "object" && !Array.isArray(dataToUse)) {
        const arrayKey = Object.keys(dataToUse).find((key) => Array.isArray(dataToUse[key]));
        if (arrayKey) {
          mainData = dataToUse?.[arrayKey];
          totalItems = dataToUse?.[totalKey] || dataToUse?.[arrayKey]?.length;
        }
      }

      setPagination((prev) => ({
        ...prev,
        total: totalItems,
      }));

      const mappedData = mainData?.map((item, i) =>
        dataMapper ? dataMapper(item, i) : ShowData(item, role, i)
      );

      let tempFilteredData = mappedData || [];
      // if (searchText) {
      //   tempFilteredData = filterDataFunc(tempFilteredData, searchText);
      // }

      setFilteredData(tempFilteredData);
      getTableData &&
        getTableData({
          data: mainData,
          filteredData: tempFilteredData,
          pagination: {
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: totalItems,
          },
        });
    } catch (error) {
      console.error("Error fetching data:", error);
      setFilteredData([]);
      setPagination((prev) => ({
        ...prev,
        total: 0,
      }));
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchData();
    }, 300); // Debounce API calls by 300ms

    return () => {
      clearTimeout(handler);
    };
  }, [
    apiFilters,
    fetchRefresh,
    searchText,
    pagination.current,
    pagination.pageSize,
    ...(callApiArgs?.dependencies || []),
  ]);

  useEffect(() => {
    const fetchFirst5000Data = async () => {
      const {
        endpoint = "",
        bodyData = {},
        queryParams = {},
        showToast = false,
        apiMethod = "get",
        useToken = true,
        accessorKey = "data",
        totalKey = "total_count",
      } = callApiArgs;

      let resFirst5000 = await callApiFirst5000({
        endpoint,
        bodyData: {
          ...bodyData,
          ...apiFilters.body,
        },
        queryParams: {
          ...queryParams,
          ...apiFilters.query,
          page: 0,
          limit: 500,
          // search: searchText,
        },
        showToast,
        apiMethod,
        useToken,
        loader: false,
      });

      const { useDecrypted = true } = callApiArgs;
      const { decrypted, responseData } = resFirst5000;
      let dataToUse = (useDecrypted ? decrypted : responseData) || {};
      setFirst5000Data(dataToUse?.[accessorKey] || []);
    };

    if (isCheck) {
      fetchFirst5000Data();
    }
  }, [apiFilters, ...(callApiArgs?.dependencies || [])]);

  console.log(
    "apiFilters, ...(callApiArgs?.dependencies || [])",
    apiFilters,
    ...(callApiArgs?.dependencies || [])
  );

  // return filteredData.length === 0 && emptyText ? (
  //   emptyText
  // ) : (
  return (
    <DataTable
      updatedColumns={updatedColumns}
      filteredData={filteredData}
      {...rest}
      pagination={pagination}
      setPagination={setPagination}
      isCheck={isCheck}
      loading={loading}
      loadingFirst5000={loadingFirst5000}
      emptyText={emptyText}
      first5000Data={first5000Data}
      dependencies={[searchText]}
      setApiFilters={setApiFilters}
    />
  );
  // );
};

const DataTable = ({
  updatedColumns,
  filteredData,
  setSelectedRows,
  auditTypeModal,
  pagination,
  setPagination,
  isCheck = false,
  loading = false,
  loadingFirst5000 = false,
  emptyText,
  first5000Data,
  dependencies,
  setApiFilters,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const { type } = useSelector((state) => state.qaType);
  const { searchText } = useSelector((state) => state.search);

  // console.log("selectedRowKeys", selectedRowKeys);

  const handleSelectFirstN = (count) => {
    const keys = first5000Data.slice(0, count).map((item) => item.id);
    setSelectedRowKeys(keys);
    setSelectedRows(first5000Data.slice(0, count));
  };

  // console.log("selectedRowKeys", selectedRowKeys);

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedKeys, selectedItems) => {
      if (!type) {
        auditTypeModal(true);
      } else {
        setSelectedRowKeys(selectedKeys);
        setSelectedRows(selectedItems);
      }
    },
    preserveSelectedRowKeys: true,
  };

  const srNoColumn = {
    title: "#",
    key: "index",
    width: 50,
    render: (_, record, index) => (pagination.current - 1) * pagination.pageSize + index + 1,
  };

  const buildSelectButtons = () => {
    return (
      <>
        {/* <Button size="small" onClick={() => handleSelectFirstN(filteredData.length)}>
          Select All
        </Button> */}

        <Button size="small" onClick={() => handleSelectFirstN(100)}>
          Select first 100
        </Button>

        <Button size="small" onClick={() => handleSelectFirstN(200)}>
          Select first 200
        </Button>

        <Button size="small" onClick={() => handleSelectFirstN(300)}>
          Select first 300
        </Button>

        <Button size="small" onClick={() => handleSelectFirstN(400)}>
          Select first 400
        </Button>

        <Button size="small" onClick={() => handleSelectFirstN(500)}>
          Select first 500
        </Button>
      </>
    );
  };

  useEffect(() => {
    // Reset to page 1 when search text or type changes
    setPagination((prev) => ({
      ...prev,
      current: 1,
      // Keep the existing pageSize when resetting
      pageSize: prev.pageSize || (isCheck ? 9 : 10),
    }));
    setSelectedRowKeys([]);
    setSelectedRows?.([]);
  }, [searchText, type, ...dependencies]);

  const sortableColumns = updatedColumns.filter(Boolean).map((col) => {
    return {
      render: (text) => (text ? text : "-"),
      ...col,
      // filters: undefined,
      // filterDropdown: undefined,
      // onFilter: undefined,
      sorter: undefined,
    }; // Remove filters and sorting from columns

    if (["Action"].includes(col.key) || col.render) {
      return col;
    }

    return {
      ...col,
      render: (text) => (text ? text : "-"),
      sorter: (a, b) => {
        const valA = a[col.dataIndex];
        const valB = b[col.dataIndex];

        // Handle null/undefined first
        if (valA == null && valB == null) return 0;
        if (valA == null) return -1;
        if (valB == null) return 1;

        // Numbers
        if (typeof valA === "number" && typeof valB === "number") {
          return valA - valB;
        }

        // Strings
        return String(valA).localeCompare(String(valB));
      },
      sortDirections: ["ascend", "descend"],
    };
  });

  const handleTableChange = (paginationConfig, filters) => {
    const api = { query: {}, body: {} };

    for (const column of sortableColumns) {
      if (!column.filterKey) continue;

      const raw = filters[column.key];
      if (!raw || raw.length === 0) continue;

      const filterIn = column.filterIn === "body" ? "body" : "query";

      if (Array.isArray(raw) && raw.length === 2) {
        const [startKey, endKey] = column.filterKey;

        //  TIME / DURATION filter
        if (column.filterFormat === "HH:mm:ss") {
          api[filterIn][startKey] = raw[0].format("HH:mm:ss");
          api[filterIn][endKey] = raw[1].format("HH:mm:ss");
        }
        //  DATE filter
        else {
          api[filterIn][startKey] = raw[0].format("YYYY-MM-DD");
          api[filterIn][endKey] = raw[1].format("YYYY-MM-DD");
        }

        continue;
      }



      api[filterIn][column.filterKey] = raw[0];
    }

    setApiFilters(api);
    setPagination({ ...pagination, ...paginationConfig });
  };

  return (
    <>
      {isCheck && !loadingFirst5000 && (
        <Alert
          // message={}
          message={
            <Space className="d-flex flex-wrap">
              {buildSelectButtons()}
              <Button
                size="small"
                type="primary"
                onClick={() => {
                  setSelectedRowKeys([]);
                  setSelectedRows([]);
                }}
              >
                Reset
              </Button>
            </Space>
          }
          type="info"
          showIcon
          closable={false}
          className="mb-2 d-flex flex-wrap gap-2"
          action={selectedRowKeys.length > 0 ? `${selectedRowKeys.length} row(s) selected` : null}
        />
      )}

      <Table
        className="custom-header-table"
        // columns={[srNoColumn, ...sortableColumns]}
        columns={[srNoColumn, ...sortableColumns]}
        dataSource={filteredData}
        rowSelection={isCheck ? rowSelection : null}
        pagination={{
          ...pagination,
          showSizeChanger: true,
          pageSizeOptions: ["5", "10", "20", "50", "100"],
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} records`,
          onChange: (page, pageSize) => {
            setPagination((prev) => ({
              ...prev,
              current: page,
              pageSize: pageSize,
            }));
          },
          onShowSizeChange: (current, size) => {
            setPagination((prev) => ({
              ...prev,
              current: 1,
              pageSize: size,
            }));
          },
        }}
        scroll={{ x: "max-content" }}
        rowKey="key"
        onChange={handleTableChange}
        loading={loading}
        locale={{ emptyText }}
      />
    </>
  );
};

export default TableComponent;
